import React from 'react';
import styled from 'styled-components';
import { FiSettings } from 'react-icons/fi';

interface SettingsButtonProps {
  onClick: () => void;
}

const Button = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: none;
  cursor: pointer;
  transition: var(--transition);
  z-index: 100;
  
  &:hover {
    background-color: #0056b3;
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }
  
  svg {
    font-size: 24px;
  }
`;

export const SettingsButton: React.FC<SettingsButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} aria-label="Abrir configurações">
      <FiSettings />
    </Button>
  );
};